import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SUBSCRIBE_MODULE_CONFIG, ISubscribeConfig } from '../config';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

export interface ISubscribeModel {
  email: string;
  agreementText: {title: string, description: string};
  reCaptchaToken: string;
}

@Injectable()
export class SubscribeService {

  constructor(
    private http: HttpClient,
    @Inject(SUBSCRIBE_MODULE_CONFIG) private config: ISubscribeConfig
  ) { }

  async subscribe(data: ISubscribeModel) {
    return await this.http.post(`${this.config.api}/NewsletterApi/subscribe`, data).toPromise();
  }
}
